import { Button, Modal, Col, Row, message } from 'antd'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { commentCheck, getCommentDetail } from '../../../../api/api'
const CommentCheckModal = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const {
    id,
    reply_content,
    reply_images,
    auditStatus,
    author,
    phone,
    content,
    threadAuditStatus,
    thread_title,
    threadType,
    post_content,
  } = props.info

  const setIsFresh = props.setIsFresh

  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOk = () => {
    const payload = {
      audit_status: 2,
      post_ids: [id],
    }
    commentCheck(payload).then((res) => {
      setIsFresh((pre) => !pre)
    })
    setIsModalOpen(false)
    message.success('评论审核通过')
  }
  const handleCancel = (e) => {
    // console.log(e.target)
    setIsModalOpen(false)
    //采用不同的回调函数
    if (e.target.innerHTML === '不通过') {
      const payload = {
        audit_status: 3,
        post_ids: [id],
      }
      commentCheck(payload).then((res) => {
        setIsFresh((pre) => !pre)
      })
      message.success('评论审核不通过')
    }
  }

  return (
    <>
      <a onClick={showModal}>审核</a>
      <Modal
        title="审核评论"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="通过"
        cancelText="不通过"
      >
        <Row style={{ marginBottom: '10px' }}>
          <Col span={12}>
            <strong>评论编号</strong> : {id}
          </Col>
          <Col span={12}>
            <strong>评论状态</strong> : {auditStatus}
          </Col>
        </Row>

        <p>
          <strong>帖子标题</strong> : {thread_title}
        </p>

        <Row style={{ marginBottom: '10px' }}>
          <Col span={12}>
            <strong>帖子状态</strong> : {threadAuditStatus}
          </Col>
          <Col span={12}>
            <strong>帖子类型 </strong>: {threadType}
          </Col>
        </Row>

        <Row style={{ marginBottom: '10px' }}>
          <Col span={12}>
            &nbsp;&nbsp;&nbsp;&nbsp;<strong>评论人</strong> : {author}
          </Col>
          <Col span={12}>
            <strong>手机号码</strong> : {phone}
          </Col>
        </Row>

        <p>
          <strong>评论内容</strong> : {content}
        </p>
        <p>
          <strong>回复内容</strong> : {reply_content}
        </p>
      </Modal>
    </>
  )
}
export default CommentCheckModal
